import script from "./PersistentBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PersistentBanner.vue?vue&type=script&setup=true&lang=js"

import "./PersistentBanner.vue?vue&type=style&index=0&id=59805156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59805156"]])

export default __exports__